module.exports = __webpack_public_path__ + "img/cerealesansgluten.fe5f70e4.png";